module.exports = __webpack_public_path__ + "img/p31.af8adf77.svg";